module.exports = __webpack_public_path__ + "static/sent-cover-d481d2d0bf85060288af442f9b1960f6.png";